<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "ClearConstantsModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      constantCount: 0,
    };
  },
  methods: {
    update() {
      this.constantCount = Object.keys(player.reality.automator.constants).length;
      if (this.constantCount === 0) this.emitClose();
    },
    deleteConstants() {
      player.reality.automator.constants = {};
      player.reality.automator.constantSortOrder = [];
    }
  }
};
</script>

<template>
  <ModalWrapperChoice
    @confirm="deleteConstants"
  >
    <template #header>
      Удаление Констант Автоматизатора
    </template>
    <div class="c-modal-message__text">
      Вы уверены, что хотите удалить все определенные в настоящий момент константы Автоматизатора?
      <br>
      <span class="l-lost-text">
        Это невозвратимо удалит {{ ruQuantify("константу,константы,констант", constantCount) }}!
      </span>
    </div>
    <template #confirm-text>
      Удалить Все
    </template>
  </ModalWrapperChoice>
</template>

<style scoped>
.l-lost-text {
  font-weight: bold;
  color: var(--color-bad);
}
</style>
